module.exports = __webpack_public_path__ + "static/media/baseline-settings_applications-24px.1e7b161a.svg";